export default function initializeFloatingLabelFix() {
    const scale = 0.85;
    const adjustmentOffset = 20;

    const applyLabelStyles = (clone, originalStyle, containerWidth) => {
        Object.assign(clone.style, {
            position: 'absolute',
            visibility: 'hidden',
            height: 'auto',
            transform: 'none',
            whiteSpace: 'normal',
            fontSize: '1rem',
            fontWeight: originalStyle.fontWeight,
            lineHeight: originalStyle.lineHeight,
            letterSpacing: originalStyle.letterSpacing,
            padding: originalStyle.padding,
            width: `${containerWidth}px`,
        });
    };

    const adjustContainerPadding = (container) => {
        const label = container.querySelector('label');
        const input = container.querySelector('input, textarea, select');

        if (!label || !input) return;

        const labelStyle = window.getComputedStyle(label);
        const containerWidth = container.clientWidth;

        // Clone label to measure natural height
        const labelClone = label.cloneNode(true);
        applyLabelStyles(labelClone, labelStyle, containerWidth);
        container.appendChild(labelClone);

        const fullHeight = labelClone.getBoundingClientRect().height;
        labelClone.remove();

        if (!fullHeight || fullHeight < 1) return;

        // Calculate padding based on scaled label height
        const unifiedPadding = Math.max(Math.floor(fullHeight * scale) - adjustmentOffset, 4);

        container.style.setProperty('--floating-label-padding-inactive', `${unifiedPadding}px`);
        container.style.setProperty('--floating-label-padding-active', `${unifiedPadding}px`);

        // Set minimum height to prevent overlap
        const inputStyles = window.getComputedStyle(input);
        const lineHeight = parseFloat(inputStyles.lineHeight) || 20;
        const paddingBottom = parseFloat(inputStyles.paddingBottom) || 8;
        const minHeight = unifiedPadding + lineHeight + paddingBottom;

        if (input.tagName.toLowerCase() === 'textarea') {
            input.style.minHeight = `${minHeight}px`;
        } else if (!inputStyles.height || parseFloat(inputStyles.height) < minHeight) {
            input.style.height = `${minHeight}px`;
        }
    };

    const adjustAllFloatingLabels = () => {
        document.querySelectorAll('.form-floating').forEach(adjustContainerPadding);
    };

    window.addEventListener('resize', adjustAllFloatingLabels);
    document.addEventListener('DOMContentLoaded', adjustAllFloatingLabels);
}
